import Spinner from "@/components/loader/Spinner";
import ProductCard from "@/components/store/ProductCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Suspense } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import "@/assets/css/ProductList.css";
import { useGetUpsellProductsQuery } from "@/store/api/productApi";
import Button from "../ui/Button";
import CloseIcon from "@/assets/img/CloseIcon";

interface ProductListProps {
  onContinueCheckout: () => void;
  onContinueCart: () => void;
}

const ProductList: React.FC<ProductListProps> = ({
  onContinueCheckout,
  onContinueCart,
}) => {
  const cartItems = useSelector((state: RootState) => state.cart.items);

  const { data } = useGetUpsellProductsQuery();

  const cartProductIds = cartItems.map((item) => item.id);
  const hasServiceInCart = useSelector(
    (state: RootState) => state.cart.hasServiceInCart,
  );

  const filteredUpsellProductsList = data?.results?.filter(
    (product) =>
      !cartProductIds.includes(product.id) &&
      (hasServiceInCart ? product.product_type === "Service" : true),
  );

  if (filteredUpsellProductsList?.length === 0) {
    onContinueCheckout();
  }

  return (
    <div className="product-list-container">
      <div className="flex justify-between">
        <h1 className="text-base sm:text-2xl font-bold mb-4">
          {"Did you forget something in your cart?"}
        </h1>
        <button
          onClick={onContinueCart}
          className="text-black-500 mb-4 flex  items-center"
        >
          <CloseIcon />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredUpsellProductsList?.map((product) => (
          <LazyLoadComponent
            key={product.id}
            placeholder={
              <div className="h-64 w-full bg-gray-200 animate-pulse"></div>
            }
          >
            <Suspense fallback={<Spinner />}>
              <ProductCard product={product} />
            </Suspense>
          </LazyLoadComponent>
        ))}
      </div>
      <div className="w-full flex justify-center">
        <Button
          variant="primary"
          text="Continue checkout"
          className="w-full h-[3rem] md:h-[3.4rem] rounded-[6px] md:rounded-[8px] 
                    text-[16px] md:text-[18px] font-bold flex items-center justify-center"
          onClick={onContinueCheckout}
        />
      </div>
    </div>
  );
};

export default ProductList;
